import { render } from "./BoqQuotation.vue?vue&type=template&id=fe45431a&scoped=true"
import script from "@/assets/boq/BoqQuotation.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqQuotation.js?vue&type=script&lang=js"

import "./BoqQuotation.vue?vue&type=style&index=0&id=fe45431a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe45431a"]])

export default __exports__